import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/js.svg
 */
const IconJs: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 2h9l5 5v13a2 2 0 01-2 2H6a2 2 0 01-2-2V4a2 2 0 012-2zm0 1h8v5h5v12a1 1 0 01-1 1H6a1 1 0 01-1-1V4a1 1 0 011-1zm12.586 4L15 3.414V7h3.586z"
      fill="currentColor"
    />
    <path
      d="M9.19 18.122c-.962 0-1.636-.387-2.02-1.163l1.04-.595c.193.385.52.577.98.577.321 0 .56-.076.718-.227.157-.152.236-.359.236-.621v-4.218h1.199v4.218c0 .641-.201 1.14-.604 1.496-.402.356-.919.534-1.549.534zM14.553 18.122c-.606 0-1.117-.134-1.53-.402a2.198 2.198 0 01-.876-1.111l1.033-.604c.239.624.708.936 1.408.936.339 0 .587-.061.744-.183a.564.564 0 00.236-.464.552.552 0 00-.288-.499c-.193-.123-.537-.254-1.033-.394a6.733 6.733 0 01-.7-.245 3.336 3.336 0 01-.569-.324 1.387 1.387 0 01-.428-.525c-.1-.21-.15-.455-.15-.735 0-.554.196-.994.587-1.32.397-.333.872-.5 1.426-.5.496 0 .93.123 1.304.368.38.24.674.575.884 1.006l-1.015.587c-.245-.525-.636-.788-1.173-.788-.25 0-.449.058-.595.175a.53.53 0 00-.21.438c0 .192.08.35.237.472.163.117.472.245.927.385.187.058.327.105.42.14.1.03.23.079.394.149.169.064.297.125.385.184.093.058.198.137.315.236.116.099.204.201.262.306.065.105.117.233.158.385.047.146.07.306.07.481 0 .566-.207 1.015-.621 1.348-.409.332-.943.498-1.602.498z"
      fill="currentColor"
    />
  </svg>
);

export default IconJs;
